export function SettingsSectionLabel({
  children,
}: {
  children: string;
}): React.JSX.Element {
  return (
    <span className="px-1 pt-1 pb-0.5 text-ui-note font-medium uppercase text-ds-slate-500">
      {children}
    </span>
  );
}
